import React, { useCallback } from "react";
import styled from "@emotion/styled";
import BrandCard from "@components/card/BrandCard";
import { EmptyText } from "@pages/saved/_components/index";
import { useInfiniteQuery } from "@tanstack/react-query";
import { LOAD_SIZE_10 } from "@libs/reactQuery/queryClient";
import { BRAND_URL } from "@libs/apiUrl";
import useAxios from "@libs/axios/useAxios";
import useIntersection from "@hook/useIntersection";

const Container = styled.div({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "2.4rem",
  padding: "4rem 2rem",
  height: "100vh",
});

const SavedBrandList = () => {
  const { axiosInstance } = useAxios();

  const getBrandList = useCallback(async ({ pageParam = 1 }) => {
    let url = `${BRAND_URL}?page=${pageParam}&limit=${LOAD_SIZE_10}&is_liked=1`;

    const res = await axiosInstance.get(url);
    if (res.status === 200) {
      return res.data;
    }
  }, []);

  const {
    data: brandList,
    fetchNextPage,
    isLoading,
    hasNextPage,
  } = useInfiniteQuery({
    queryKey: ["brandList"],
    queryFn: ({ pageParam = 1 }) => getBrandList({ pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPages, pages) =>
      pages?.length < lastPages.data.total_count / LOAD_SIZE_10
        ? pages.length + 1
        : undefined,
  });

  const { setObserverTarget } = useIntersection(() => {
    fetchNextPage();
  });

  return (
    <Container>
      {(brandList?.pages[0].data.list.length === 0 || isLoading) && (
        <EmptyText type="brand" />
      )}

      {brandList?.pages?.map((page) => {
        return page?.data?.list?.map((item: any) => (
          <BrandCard
            key={item.brand_id}
            id={item.brand_id}
            name={item.brand_name_en}
            koreanName={item.brand_name_ko}
            src={item.logo_url}
            liked={item.is_liked !== 0}
            withImage
            imageList={item.image_list}
          />
        ));
      })}

      {!!isLoading && !!hasNextPage && <div ref={setObserverTarget} />}
    </Container>
  );
};

export default SavedBrandList;
